module.exports = __webpack_public_path__ + "resources/img/img_dvision7_m.7b28bdfe67f0d127b7968f27b1e7b931.png";